import { gql } from '@apollo/client';
export const EXPORT_RUN_FIELDS = gql `
  fragment ExportRunFields on ExportRun {
    id
    createdAt
    updatedAt
    clientId
    exportId
    exportName
    numRowsExported
    s3Key
    startedAt
    completedAt
    status
    error
    extraData {
      processAllClients
      childClientIds
    }
  }
`;
export const EXPORT_RUNS = gql `
  ${EXPORT_RUN_FIELDS}
  query EXPORT_RUNS($spec: ExportRunSpec!) {
    exportRuns(spec: $spec) {
      total
      page
      pageSize
      items {
        ...ExportRunFields
      }
    }
  }
`;
export const DOWNLOAD_EXPORT = gql `
  query DOWNLOAD_EXPORT($id: Int!) {
    downloadExport(id: $id)
  }
`;
